import { Link } from "react-router-dom";

export default function Breadcrumbs({ pages }) {
  return (
    <nav aria-label="Breadcrumb" className="flex my-4">
      <ol className="flex items-center space-x-4">
        <li>
          <div>
            <Link
              to="/"
              className="text-sm font-medium text-gray-800 hover:text-gray-900"
            >
              Home
            </Link>
          </div>
        </li>
        {pages.map((page) => (
          <li key={page.name}>
            <div className="flex items-center">
              <svg
                fill="currentColor"
                viewBox="0 0 20 20"
                aria-hidden="true"
                className="h-5 w-5 flex-shrink-0 text-gray-300"
              >
                <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
              </svg>
              <Link
                to={page.href}
                aria-current={page.current ? "page" : undefined}
                className={`ml-4 text-sm font-medium ${
                  page.current
                    ? "text-gray-500 hover:text-gray-600"
                    : "text-gray-800 hover:text-gray-900"
                }`}
              >
                {page.name}
              </Link>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}
